export default {
  SET_METHODS: function (state, payloads) {
    state.methods = payloads;
  },
  SET_ALL_PAY_METHODS: function (state, payloads) {
    state.allPayMethods = payloads;
  }

}
